import { ANALYTICS_ALL_STRING, UNKNOWN_CURRENCY_PREFIX } from 'src/constants';
import { getIntl } from 'src/services/intl/intl';

export const isUnknownCurrency = (currency: string) => currency.startsWith(UNKNOWN_CURRENCY_PREFIX);

export const prepareCurrencyLabel = (currency: string) => {
  if (isUnknownCurrency(currency)) {
    return `Currency ${currency.substring(UNKNOWN_CURRENCY_PREFIX.length)}`;
  }

  return currency;
};

export const prepareIntlWithCurrency = (id: string, currency: string, withBreak = false) => {
  const formattedCurrency = prepareCurrencyLabel(currency === ANALYTICS_ALL_STRING ? 'EUR' : currency).replace(
    'EUR',
    '€',
  );

  return getIntl()
    .formatMessage({ id }, { currency: formattedCurrency })
    .replace(', ', withBreak ? ',\n' : ', ');
};
